<template>
<div class="limiter">
  <div class="container-login">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
            <span class="login-title">
              <img src="../../assets/logoAICheckinIntelite-preto.png"  width="100%" style="max-width: 250px">
            </span>
            <v-card-text style="padding: 0px">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg12>
                    <v-data-table
                      :headers="tabela.cabecalho"
                      :items="tabela.conteudo"
                      class="elevation-0"
                      hide-default-footer
                      disable-sort
                      :style="tabela.conteudo.length > 0 ? 'border: 1px #aaa solid' : ''"
                      dense
                      :hide-default-header="tabela.conteudo.length == 0"
                    >
                      <template v-slot:[`item.acoes`]="{ item }">
                        <v-btn @click="editarItem(item)" color="primary" depressed small :disabled="!item.autopreenchimento">
                          <v-icon left>edit</v-icon>Editar
                        </v-btn>
                      </template>
                      <template v-slot:no-data>
                        <v-alert type="warning" dense style="margin: 0px">Inscrição não localizada.</v-alert>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- <br>
      <div class="login-title">
        <a href="https://www.intelitetecnologia.com.br/" target="_blank">
          <img src="../../assets/logoAICheckinIntelite-preto.png"  width="250px">
        </a>
      </div> -->

      <v-dialog v-model="dialogoEdicaoInscricao" persistent max-width="500px" scrollable>
        <v-card>
          <v-card-title>Editar informações</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field label="CPF" v-model="inscricao.cpf" light color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required type="tel"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="NOME COMPLETO" v-model="inscricao.nome" light outlined color="#00695C" dense hide-details required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="NOME PARA O CRACHÁ" v-model="inscricao.nomeCracha" light color="#00695C" outlined hide-details dense required maxlength="26"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="CARGO" v-model="inscricao.cargo" light color="#00695C" outlined hide-details dense required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select label="SEXO" v-model="inscricao.sexo" outlined dense :items="sexo" hide-details color="#00695C"></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field label="WHATSAPP COM DDD" v-model="inscricao.telefone" light color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="E-MAIL" v-model="inscricao.email" light color="#00695C" type="text" outlined hide-details dense required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="DATA DE NASCIMENTO" v-model="inscricao.dataNascimento" light color="#00695C" type="text" outlined hide-details v-mask="'##/##/####'" dense required></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text depressed color="red" @click="dialogoEdicaoInscricao = false">Fechar</v-btn>
            <v-btn text depressed color="green" @click="salvarInscricao">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import axios from 'axios'

  export default {
    components: {
      Snackbar,
      Loading
    },

    name: 'Auth',

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        mask: "###.###.###-##",
        inscricao: {
          nome: '',
          cpf: '',
          nomeCracha: '',
          cargo: '',
          sexo: '',
          telefone: '',
          email: '',
          dataNascimento: '',
        },
        dialogoEdicaoInscricao: false,
        sexo: ['MASCULINO', 'FEMININO'],
        isLoading: false,
        fullPage: true,
        tabela: {
          cabecalho: [
            { text: 'Nome', value: 'nome' },
            { text: 'CPF', value: 'cpf' },
            { text: 'Ações', value: 'acoes' },
          ],
          conteudo: [],
        }
      }
    },

    mounted: function () {
      this.pegaParametrosUrl()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      async pegaParametrosUrl() {
        this.isLoading = true

        var params = window.location.search.substring(1).split('&');

        if (params[0] != '') {
          var paramArray = {};                    // Criar objeto que vai conter os parametros
          for (var i=0; i<params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');     // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];      // Adicionar ao objeto criado antes
          }

          if (paramArray['cod']) {
            this.pegaInscricao(paramArray['cod'])
          }
        }

        this.isLoading = false
      },

      async pegaInscricao(codInscricao) {
        this.tabela.conteudo = []

        await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCodigo2', {"cod_incricao": codInscricao})
        .then(response => {
          if (response.data) {
            this.tabela.conteudo.push(response.data)
          }
        })
        .catch(() => {
          this.tabela.conteudo = []
        })
      },

      editarItem(item) {
        this.inscricao = Object.assign({}, item)
        this.dialogoEdicaoInscricao = true
      },

      async salvarInscricao() {
        let vm = this

        if (!this.inscricao.cpf || !this.inscricao.nome || !this.inscricao.nomeCracha || !this.inscricao.cargo || !this.inscricao.sexo || !this.inscricao.telefone || !this.inscricao.email || !this.inscricao.dataNascimento) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos", "ATENÇÃO")
        }
        else if (!CpfValidate(this.inscricao.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe um CPF válido", "ATENÇÃO")
        }
        else {
          this.isLoading = true
          this.inscricao.autopreenchimento = false

          await axios.post(baseApiUrl + 'inscricoes/criarInscricoes', [this.inscricao])
          .then(response => {
            if (response.data) {
              this.dialogoEdicaoInscricao = false
              this.pegaInscricao(response.data[0].cod_incricao)
              vm.$refs.chamaSnackbar.snack("green", "Informações salvas!", "SUCESSO")
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FF0000", "Problema ao salvar inscrição", "DESCULPE")
          })
        }

        this.isLoading = false
      },
    }
  }
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #424242, #616161);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}
</style>
